<template>
  <div class="focus_warp ">
    <van-overlay :show="FoShow" >
        <div class="focus_main">
            <div class="focus_pop">
                <div class="inquiry_title">申请{{title}}</div>
                <div class="focut_content">
                    <div class="input_read" style="background: #fff;border: 1px solid #efefef">
                    <p>姓名</p>
                    <input type="text" v-model="name" maxlength="11" placeholder="请输入姓名 " />
                    </div>
                    <div class="input_read" style="background: #fff;border: 1px solid #efefef">
                    <p>公司</p>
                    <input type="text" v-model="companyName" maxlength="11" placeholder="请输入公司名" />
                    </div>
                    <div class="input_read">
                    <p>手机</p>
                    <input type="tel" v-model="phone" maxlength="11" placeholder="请输入手机号" />
                    <!-- <p>{{phone}}</p> -->
                    </div>

                    <textarea
                    v-if="FoShow"
                    class="text_area van-cell van-field van-field--min-height"
                    :placeholder="title == '上直播' ? '直播简介' : '备注'"
                    placeholder-class="placeholder"
                    fixed="true"
                    v-model="content"
                    name="text"
                    maxlength="100"
                    />
                </div>
                <div class="submit_btn">
                    <span @click="resetForm">取消</span>
                    <span @click="submit">提交</span>
                </div>
            </div>
        </div>
    </van-overlay>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "inquiry",
  data() {
    return {
      name: "",
      phone: "",
      content: "",
      companyName: "",
      title: "",
      FoShow: false,
      isHasMob: false
    };
  },
  computed: {
    ...mapGetters({
      exhibitorId: "company/getExhibitorId",
      companyId: "company/getCompanyId",
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
    })
  },
  methods: {
    ...mapActions({
        applyhot: "act/applyhot",
        applyfocus: "act/applyfocus"
    }),
    open(title) {
        this.FoShow = true;
        this.title = title;
        this.name = this.userInfo.name || this.userInfo.nickName;
        this.phone = this.userInfo.phone;
        this.companyName = this.userInfo.company||'';
    },
    async submit() {
        if (!this.name) {
            this.$toast.fail('请输入姓名！')
            return false;
        }
        if (!this.companyName) {
            this.$toast.fail('请输入公司名！')
            return false;
        }
        let opt = {
            inMemberId: this.userInfo.inMember.id,  // 用户的inmember的id
            exhibitionId: this.exhibitionId,
            name: this.name,
            compName: this.companyName,
            phoneNumber: this.phone,
            remarks: this.content
        };

        if (this.title == "上直播") {
            let focusdata = await this.applyfocus(opt);
            if (focusdata) {
                this.$toast.success('提交成功！')
                this.resetForm();
            } else {
               this.$toast.fail('提交失败！')
            }
        } else { // 热榜
            let hotdata = await this.applyhot(opt);
            if (hotdata) {
                this.$toast.success('提交成功！')
                this.resetForm();
            } else {
                this.$toast.fail('提交失败！')
            }
        }
    },
    resetForm() {
      this.name = "";
      this.phone = "";
      this.content = "";
      this.FoShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.focus_warp{
    z-index: 200;
    position: relative;
    .focus_main{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }
   .focus_pop {
    width: 5.6rem;
    height: 6.36rem;
    padding: 0.35rem 0.35rem 0;
    background: #fff;
    border-radius: 0.15rem;
    position: relative;
    .inquiry_title {
      font-size: 0.3rem;
      text-align: center;
      color: #333;
      line-height: 1.2;
      margin-bottom: 0.23rem;
      letter-spacing: 1px;
      padding-left: 1px;
      font-weight: 600;
    }
    .submit_btn {
      height: .9rem;
      width: 100%;
      display: flex;
      position: absolute;
      border-top: 1px solid #efefef;
      left: 0;
      right: 0;
      bottom: 0;
      span {
        line-height: 1rem;
        height: .89rem;
        border: none;
        border-radius: 0;
        color: #333;
        font-size: 0.3rem;
        width: 100%;
        text-align: center;
        &:first-child {
          border-right: 1px solid #efefef;
        }
        &:last-child {
          color: #fe5502;
        }
      }
    }
    .focut_content {
      .input_read {
        background: #eee;
        color: #666;
        padding: 0 0.2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.7rem;
        margin-bottom: 0.2rem;
        line-height: 0.7rem;
        p {
          font-size: 0.26rem;
          width: 30%;
        }
        input {
          width: 70%;
          outline: none;
          border: none;
          background: #fff;
          text-align: right;
          // padding: 0.15rem 0;
          font-size: 0.26rem;
          box-sizing: border-box;
          height: 100%;
        }
        input[type="tel"]{
          background: #eee;
        }
      }
      .placeholder {
        font-size: .26rem;
      }
      .text_area {
        border: 1px solid #eee;
        height: 1.4rem;
        padding: 0.1rem 0.2rem;
        box-sizing: border-box;
        width: 100%;
        font-size: 0.26rem;
        line-height: 0.38rem;
        color: #333;
        .van-field__body {
          .van-field__control {
            min-height: 0.95rem;
            font-size: 0.26rem;
            line-height: 0.38rem;
            &::-webkit-input-placeholder {
              /* WebKit browsers */
              color: #bfbfbf;
            }
            &:-moz-placeholder {
              /* Mozilla Firefox 4 to 18 */
              color: #bfbfbf;
            }
            &::-moz-placeholder {
              /* Mozilla Firefox 19+ */
              color: #bfbfbf;
            }
            &:-ms-input-placeholder {
              /* Internet Explorer 10+ */
              color: #bfbfbf;
            }
          }
        }
        .van-field__word-limit {
          line-height: 1;
          font-size: 0.24rem;
          margin-top: 0;
        }
      }
    }
  }
}
input,textarea{-webkit-appearance: none;border-radius:0;}
</style>
